import { useState } from "react";
import { CopyButton } from "./primitives.jsx";

export function ProtocolTabs({ examples }) {
  const keys = Object.keys(examples);
  const [active, setActive] = useState(keys[0]);
  const activeExample = examples[active];

  if (!activeExample) {
    return <p className="lbl">No protocol examples are available.</p>;
  }

  return (
    <div className="protocol-browser">
      <div className="protocol-browser__tabs" role="tablist" aria-label="Protocol examples">
        {keys.map((key) => (
          <button
            key={key}
            type="button"
            role="tab"
            aria-selected={active === key}
            className="tab"
            data-active={active === key ? "" : undefined}
            onClick={() => setActive(key)}
          >
            {examples[key].label}
          </button>
        ))}
      </div>
      <div className="protocol-browser__panel" role="tabpanel">
        <div className="protocol-browser__top">
          <span className="lbl">{activeExample.label}</span>
          <CopyButton text={JSON.stringify(activeExample.code, null, 2)} />
        </div>
        <pre><code>{JSON.stringify(activeExample.code, null, 2)}</code></pre>
      </div>
    </div>
  );
}
